
import React from 'react';

export const PaginationButton = ({
	activeButton,
	disabled,
	ariaLabel,
	onclick,
	children
}) => {

	return (
		<div className='pagination-button-wrapper'>
			{disabled ? (
				<div className='button-base-style pagination-div'>{children}</div>
			) : (
				<button
					aria-label={ariaLabel}
					type="button"
					onClick={onclick}
					className={`button-base-style pagination-button ${activeButton ? 'active-button' : ''}`}
				>
					{children}
				</button>
			)}
		</div>
	);
};
